<section>
  <h4 i18n>Allgemeine Angaben</h4>
  <mat-form-field>
    <mat-label i18n>Name</mat-label>
    <input matInput formControlName="name" />
    @if (eventForm.controls.name.errors?.required) {
      <mat-error i18n>Der Name darf nicht leer sein</mat-error>
    }
    @if (eventForm.controls.name.errors?.nameConflict) {
      <mat-error i18n>Dieser Name wird bereits von einer anderen Veranstaltung benutzt</mat-error>
    }
    <mat-hint i18n>Die Veranstaltung erscheint unter diesem Namen</mat-hint>
  </mat-form-field>
  <mat-slide-toggle formControlName="enableRegistration" i18n>Registrierung freischalten</mat-slide-toggle>
  @if (eventForm.controls.enableRegistration.value) {
    <mat-form-field>
      <mat-label i18n>Registrierungs-Code</mat-label>
      <input matInput formControlName="code" />
      @if (eventForm.controls.code.errors?.minlength) {
        <mat-error i18n>Der Code muss mindestens 3-stellig sein</mat-error>
      }
      @if (eventForm.controls.code.errors?.codeConflict) {
        <mat-error i18n>Dieser Code wird bereits von einer anderen Veranstaltung benutzt</mat-error>
      }
      <mat-hint i18n>Mit diesem Code können sich Interessenten für die Veranstaltung registrieren</mat-hint>
    </mat-form-field>
  }
  <mat-form-field>
    <mat-label i18n>Start des Abgabezeitraums</mat-label>
    <input matInput type="datetime-local" formControlName="startDate" (blur)="onDatetimeFieldBlur($event, eventForm.controls.startDate)" />
    <mat-hint i18n>Ab diesem Zeitpunkt kann abgegeben werden (leer bedeutet unlimitiert)</mat-hint>
    <button mat-icon-button matSuffix type="button" (click)="clearDateField(eventForm.controls.startDate)"
      ><mat-icon>clear</mat-icon></button
    >
    @if (eventForm.controls.startDate.errors?.incomplete) {
      <mat-error i18n>Das Datum muss vollständig definiert werden</mat-error>
    }
  </mat-form-field>
  <mat-form-field>
    <mat-label i18n>Ende des Abgabezeitraums</mat-label>
    <input matInput type="datetime-local" formControlName="endDate" (blur)="onDatetimeFieldBlur($event, eventForm.controls.endDate)" />
    <mat-hint i18n>Bis zu diesem Zeitpunkt kann abgegeben werden (leer bedeutet unlimitiert)</mat-hint>
    <button mat-icon-button matSuffix type="button" (click)="clearDateField(eventForm.controls.endDate)"><mat-icon>clear</mat-icon></button>
    @if (eventForm.controls.endDate.errors?.incomplete) {
      <mat-error i18n>Das Datum muss vollständig definiert werden</mat-error>
    }
    @if (eventForm.controls.endDate.errors?.dateRangeInvalid) {
      <mat-error i18n>Das Enddatum liegt vor dem Startdatum</mat-error>
    }
  </mat-form-field>
</section>
<section formGroupName="requirements">
  <h4 i18n>Anforderungen an das Projekt</h4>
  <p class="mat-caption" i18n>Nur Projekte, die diese Anforderungen erfüllen, können abgegeben werden.</p>
  <mat-checkbox formControlName="decisionStatement" i18n>Entscheidungsfrage ausgefüllt</mat-checkbox>
  <mat-checkbox formControlName="objectives" i18n>Ziele formuliert</mat-checkbox>
  <mat-checkbox formControlName="alternatives" i18n>Alternativen formuliert</mat-checkbox>
  <mat-checkbox formControlName="impactModel" i18n>Wirkungsmodell ausgefüllt</mat-checkbox>
  <mat-checkbox formControlName="objectiveWeights" i18n>Zielgewichte definiert</mat-checkbox>
  <mat-checkbox formControlName="decisionQuality" i18n>Entscheidungsqualität bewertet</mat-checkbox>
</section>
<section>
  <h4 i18n>Freitextfeld zur Abgabe</h4>
  <mat-slide-toggle formControlName="freeTextEnabled" i18n>Freitextfeld aktiviert</mat-slide-toggle>
  @if (eventForm.controls.freeTextEnabled.value) {
    <ng-container formGroupName="freeTextParameters">
      <mat-form-field>
        <mat-label i18n>Name</mat-label>
        <input matInput formControlName="name" />
        <mat-hint i18n>Das Freitextfeld bekommt diese Bezeichnung</mat-hint>
      </mat-form-field>
      <mat-form-field>
        <mat-label i18n>Platzhalter</mat-label>
        <input matInput formControlName="placeholder" />
        <mat-hint i18n>Der Platzhalter wird angezeigt, wenn das Freitextfeld leer ist</mat-hint>
      </mat-form-field>
      <mat-form-field>
        <mat-label i18n>Minimale Anzahl Zeichen</mat-label>
        <input matInput type="number" formControlName="minLength" />
        <mat-hint i18n>Teilnehmende können nur abgeben, wenn sie diese Mindestanforderung erfüllen</mat-hint>
        @if (eventForm.controls.freeTextParameters.controls.minLength.errors?.min) {
          <mat-error i18n>Die Zeichenanzahl muss mindestens 0 sein</mat-error>
        }
      </mat-form-field>
    </ng-container>
  }
</section>
<section>
  <h4 i18n>Datenverwendung</h4>
  <mat-slide-toggle formControlName="requireDataUsageAuthorization" i18n>Erlaubnis zur Datennutzung fordern</mat-slide-toggle>
  @if (!eventForm.controls.requireDataUsageAuthorization.value && eventForm.controls.requireDataUsageAuthorization.dirty) {
    <mat-error class="dt-error" i18n>Diese Einstellung kann nach dem Erstellen der Veranstaltung nicht mehr geändert werden</mat-error>
  }
</section>
